/**
 * UpdateBanner — shown when a new service worker is waiting to activate.
 * User taps "Actualizar" and the page reloads with the new version.
 */
import React from 'react';

export default function UpdateBanner({ onUpdate }) {
  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
      background: '#1a472a', color: '#fff',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '0.75rem 1.25rem', gap: '1rem',
      boxShadow: '0 -2px 12px rgba(0,0,0,0.3)',
    }}>
      <span style={{ fontSize: '0.9rem' }}>
        Nueva versión disponible
      </span>
      <button
        onClick={onUpdate}
        style={{
          background: '#fff', color: '#1a472a', border: 'none',
          borderRadius: '0.5rem', padding: '0.4rem 1rem',
          fontWeight: 700, cursor: 'pointer', fontSize: '0.85rem',
          flexShrink: 0,
        }}
      >
        Actualizar
      </button>
    </div>
  );
}
